import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router";
import { useSession } from "@/app/session";
import { Alert, Button } from "@/components/ui";
import { authClient } from "@/lib/authClient";
import { useT } from "@/lib/i18n";
import { AuthLayout } from "./AuthLayout";

/** Landing page for magic links: the token is only consumed when the person clicks, so mail scanners can't burn it. */
export default function MagicLanding() {
  const t = useT();
  const [params] = useSearchParams();
  const token = params.get("token") ?? "";
  const next = params.get("callbackURL") ?? "/";
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const nav = useNavigate();
  const { refresh } = useSession();

  async function go() {
    setBusy(true);
    const r = await authClient.magicLink.verify({ query: { token } });
    if (r.error) {
      setError(t.magicInvalid);
      setBusy(false);
      return;
    }
    await refresh();
    nav(next.startsWith("/") ? next : "/", { replace: true });
  }

  return (
    <AuthLayout title={t.signIn}>
      {!token ? <Alert kind="error">{t.magicInvalid}</Alert> : null}
      {error ? <Alert kind="error">{error}</Alert> : null}
      {token && !error ? (
        <Button className="w-full" onClick={go} loading={busy}>
          {t.signIn}
        </Button>
      ) : (
        <Link to="/login" className="mt-4 inline-block text-sm font-semibold">
          {t.back}
        </Link>
      )}
    </AuthLayout>
  );
}
